import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ClientBrowserSessionStorageService } from '../services/client-browser-session-storage.service';
import { Commons } from '../shared/Commons';
import { AlertModalComponent } from '../shared/modals/alert-modal/alert-modal.component';

export const customerGuard: CanActivateFn = (_r, _s): boolean | UrlTree => {

  /* ---------- detección de plataforma ---------- */
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  /* ---------- dependencias comunes ---------- */
  const router = inject(Router);

  /* ---------- si es SSR / prerender ---------- */
  if (!isBrowser) {
    // ⇨ deja pasar para que la generación de HTML no se bloquee
    //    (o redirige a login si prefieres ocultar la zona)
    return true;
  }

  /* ---------- sólo en el navegador ---------- */
  const modalService = inject(MdbModalService);
  const sessionStorage = inject(ClientBrowserSessionStorageService);

  const loggedIn = Commons.sessionIsOpen(sessionStorage);
  const sessionObject = loggedIn ? Commons.sessionObject(sessionStorage) : null;
  const sessionRol = sessionObject?.customer?.rol;

  const authorized =
    loggedIn &&
    [Commons.USER_ROL_BASIC, Commons.USER_ROL_RW, Commons.USER_ROL_RWX]
      .includes(sessionRol);

  if (authorized) {
    return true;           // ✅ acceso permitido
  }

  /* ---------- acceso denegado ---------- */
  modalService.open(AlertModalComponent, {
    data: {
      title: 'validations.not-allowed',
      message: 'validations.customer-not-allowed',
      icon: Commons.ICON_WARNING
    }
  });

  // redirección adecuada
  return loggedIn
    ? router.createUrlTree([Commons.PATH_MAIN])
    : router.createUrlTree([Commons.PATH_LOGIN]);
};
